export default __webpack_public_path__ + "static/media/fetch-data.6db46c8c.jpeg";